import {
  Text,
  GreyGrey80,
  Primary13Regular,
  SimpleModal
} from '@sequencehq/core-components'
import { match } from 'ts-pattern'

type ResultType = 'invoice' | 'credit-note'

type Props = {
  isOpen: boolean
  onClose: () => void
  resultType: ResultType
  onConfirm: () => void
}

export const RecalculationFlipResultDialog = ({
  isOpen,
  onClose,
  resultType,
  onConfirm
}: Props) => {
  const { title, description, submitButtonText } = match(resultType)
    .with('credit-note', () => ({
      title: 'Credit note created',
      description:
        'Recalculation determined that a refund is owed. A credit note has been created and the original invoice has been removed.',
      submitButtonText: 'Go to credit note'
    }))
    .with('invoice', () => ({
      title: 'Invoice created',
      description:
        'Recalculation determined that an amount is owed. An invoice has been created and the original credit note has been removed.',
      submitButtonText: 'Go to invoice'
    }))
    .exhaustive()

  return (
    <SimpleModal
      data-testid="modal.recalculate-flip-result"
      variant="dialog"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={() => {
        onConfirm()
        return true
      }}
      title={title}
      submitButtonText={submitButtonText}
      showCancelButton={false}
    >
      <Text {...Primary13Regular} color={GreyGrey80}>
        {description}
      </Text>
    </SimpleModal>
  )
}
